var map = {
	"./aed.png": 816,
	"./aud.png": 817,
	"./bgn.png": 818,
	"./bhd.png": 819,
	"./cad.png": 820,
	"./chf.png": 821,
	"./cnh.png": 822,
	"./cny.png": 823,
	"./czk.png": 824,
	"./dkk.png": 825,
	"./eur.png": 826,
	"./gbp.png": 827,
	"./hkd.png": 828,
	"./hrk.png": 829,
	"./huf.png": 830,
	"./idr.png": 831,
	"./ils.png": 832,
	"./inr.png": 833,
	"./jpy.png": 834,
	"./kes.png": 835,
	"./kwd.png": 836,
	"./mxn.png": 837,
	"./myr.png": 838,
	"./nok.png": 839,
	"./nzd.png": 840,
	"./omr.png": 841,
	"./php.png": 842,
	"./pln.png": 843,
	"./qar.png": 844,
	"./ron.png": 845,
	"./rub.png": 846,
	"./sar.png": 847,
	"./sek.png": 848,
	"./sgd.png": 849,
	"./thb.png": 850,
	"./try.png": 851,
	"./ugx.png": 852,
	"./usd.png": 853,
	"./zar.png": 854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 815;